var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dataKanban" },
    [
      _c(
        "Row",
        [
          _c("Col", { attrs: { span: "12" } }, [
            _c("div", { staticClass: "right_box" }, [
              _c("div", { staticClass: "right_content" }, [
                _c("div", { staticClass: "right_title" }, [
                  _c("span", { staticClass: "block" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("空白市场排行")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right_title_left" },
                  [
                    _c(
                      "RadioGroup",
                      {
                        attrs: { type: "button", size: "small" },
                        on: { "on-change": _vm.whiteRadioChange },
                        model: {
                          value: _vm.whiteRadio,
                          callback: function ($$v) {
                            _vm.whiteRadio = $$v
                          },
                          expression: "whiteRadio",
                        },
                      },
                      [
                        _c("Radio", { attrs: { label: "按大区排名" } }),
                        _vm._v(" "),
                        _c("Radio", { attrs: { label: "按省排名" } }),
                        _vm._v(" "),
                        _c("Radio", { attrs: { label: "按市排名" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "echarts_box" },
                [
                  _c("div", {
                    style: { width: "400px", height: "350px" },
                    attrs: { id: "drawLineWhite" },
                  }),
                  _vm._v(" "),
                  _c("Table", {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      height: "150",
                      columns: _vm.columns,
                      data: _vm.data,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("Col", { attrs: { span: "12" } }, [
            _c("div", { staticClass: "left_box" }, [
              _c("div", { staticClass: "left_box_top" }, [
                _c("div", { staticClass: "left_content" }, [
                  _c("div", { staticClass: "left_title" }, [
                    _c("span", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("店铺新开趋势")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button", size: "small" },
                          on: { "on-change": _vm.newOpenButtonChange },
                          model: {
                            value: _vm.newOpenButton,
                            callback: function ($$v) {
                              _vm.newOpenButton = $$v
                            },
                            expression: "newOpenButton",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "近3个月" } }),
                          _vm._v(" "),
                          _c("Radio", { attrs: { label: "近6个月" } }),
                          _vm._v(" "),
                          _c("Radio", { attrs: { label: "近一年" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "echarts_box" }, [
                  _c("div", {
                    style: { width: "400px", height: "250px" },
                    attrs: { id: "drawLineNewOpen" },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "left_box_bottom" }, [
                _c("div", { staticClass: "left_content" }, [
                  _c("div", { staticClass: "left_title" }, [
                    _c("span", { staticClass: "block" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("店铺关闭原因分析")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "left_title_left" },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button", size: "small" },
                          on: { "on-change": _vm.closeReasonChnage },
                          model: {
                            value: _vm.closeReasonRadio,
                            callback: function ($$v) {
                              _vm.closeReasonRadio = $$v
                            },
                            expression: "closeReasonRadio",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "近3个月" } }),
                          _vm._v(" "),
                          _c("Radio", { attrs: { label: "近6个月" } }),
                          _vm._v(" "),
                          _c("Radio", { attrs: { label: "自定义时间" } }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showDate
                        ? _c("DatePicker", {
                            staticStyle: {
                              width: "200px",
                              "margin-top": "6px",
                            },
                            attrs: {
                              type: "daterange",
                              placement: "bottom-end",
                              placeholder: "请选择日期",
                              value: _vm.changeDateValue,
                            },
                            on: {
                              "on-change": _vm.onChange,
                              "on-open-change": _vm.onOpenChange,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "echarts_box echarts_box_bottom" }, [
                  _c("div", {
                    style: { width: "50%", height: "200px" },
                    attrs: { id: "drawLineCloseReason" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "line_box" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "legend_box" },
                    _vm._l(
                      this.closeReasonOptions.series[0].data,
                      function (item, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "legend_content" },
                          [
                            _c("div", { staticClass: "legend_right" }, [
                              _c("span", {
                                staticClass: "legend",
                                style: {
                                  border: " 2px" + item.color + " solid ",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.name))]),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  ((item.value / _vm.allCounts) * 100).toFixed(
                                    2
                                  )
                                ) + "%"
                              ),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }